export const categories = {
	basicNeeds: 0,
	humanRights: 1,
	education: 2,
	emergency: 3,
	feeding: 4,
	environment: 5,
	habitat: 6,
	health: 7,
} as const;

export const categoriesKeys = [
	'basicNeeds',
	'humanRights',
	'education',
	'emergency',
	'feeding',
	'environment',
	'habitat',
	'health',
] as const;

export type CategoryKey = (typeof categoriesKeys)[number];

export type Category = (typeof categories)[keyof typeof categories];

export const beneficiaryTypes = [
	'children',
	'youth',
	'elderly',
	'women',
	'men',
	'lgbtiq',
	'disabilities',
	'refugees',
	'homeless',
	'animals',
	'ecosystems',
] as const;

export type BeneficiaryType = (typeof beneficiaryTypes)[number];

export const subcategoriesByCategory: Record<CategoryKey, string[]> = {
	basicNeeds: ['water_access', 'energy_access', 'sanitation', 'infrastructure'],
	humanRights: ['gender_equality', 'child_protection', 'legal_aid', 'freedom_expression', 'labor_rights'],
	education: ['primary_education', 'vocational_training', 'digital_literacy', 'scholarships', 'job_insertion'],
	emergency: ['natural_disasters', 'conflict_response', 'refugee_aid', 'medical_emergency', 'reconstruction'],
	feeding: ['food_distribution', 'nutrition_programs', 'agricultural_support', 'food_security', 'school_meals'],
	environment: ['reforestation', 'climate_action', 'waste_management', 'biodiversity', 'renewable_energy'],
	habitat: ['social_inclusion', 'housing', 'community_development', 'poverty_reduction', 'elderly_care'],
	health: ['primary_healthcare', 'mental_health', 'maternal_health', 'disease_prevention', 'medical_equipment'],
};
